import { InjectionKey } from 'vue';
import { RequestService } from '@ads/iam-library';
import VideoUploadService from '@/services/video/VideoUploadService';

export const creativeHubApiRequestServiceKey = Symbol('CreativeHubApiRequestService') as InjectionKey<RequestService>;
export const videoUploadServiceKey = Symbol('VideoUploadService') as InjectionKey<VideoUploadService>;
